import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import MessagingThread from "../../model/messagingThread.model";
import {BehaviorSubject, Observable, skipWhile} from "rxjs";
import MessagingThreadEntry from "../../model/messagingThreadEntry.model";
import Pagination from "../../model/pagination";
import {environment} from "../../environments/environment";
import Crypto from "../../helper/crypto";
import MessagingPagination from "../../model/messagingPagination.model";
import MessagingMessage from "../../model/messagingMessage.model";
import {cache} from "../../cache";

@Injectable()
export default class MessagingThreadEntryService {
    constructor(private http: HttpClient) {
    }

    public list(thread: MessagingThread, page?: number, limit?: number): Observable<Pagination<MessagingThreadEntry>> {
        let queryParams = {
            threadId: thread.id,
            page: page || 1,
            limit: limit || 15
        };
        let queryString = [];
        for(let key of Object.keys(queryParams)) {
            queryString.push(key + '=' + queryParams[key]);
        }


        const key = 'cache-' + Crypto.SHA1('messaging/thread-entries?' + queryString.join('&'));
        const subject = new BehaviorSubject<Pagination<MessagingThreadEntry>>(null);

        const cachedResult = localStorage.getItem(key);

        if(page == 1) {
            cache.getCacheItem(key).then(result => {
                if(result) {
                    subject.next(JSON.parse(result.result));
                }
            });
        }


        this.http.get<Pagination<MessagingThreadEntry>>(environment.apiUrl + '/messaging/thread-entries?' + queryString.join('&')).subscribe(result => {
            subject.next(result);
            cache.removeCacheItem(key).then(_ => {
                cache.insertCacheItem({
                    id: key,
                    result: JSON.stringify(result)
                });
            });
        });

        return subject.pipe(skipWhile(e => {
            return e == null
        }));
    }

    public show(id): Observable<MessagingThreadEntry> {
        return this.http.get<MessagingThreadEntry>(environment.apiUrl + '/messaging/thread-entries/' + id);
    }
}
